import CoreAndCatchUp from './model';
import create from './create';
import * as _actions from './actions';
import _reducer from './reducer';

CoreAndCatchUp.create = create;

export default CoreAndCatchUp;

export const actions = _actions;
export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/WritingAssignment/CoreAndCatchUp/index.js